import { Box } from '@mui/material'
import Container from '@mui/material/Container'
import { ArchiveInfoCard } from 'Components/_common/ArchiveEvent/ArchiveInfoCard'
import MobileMainHeader from 'Components/_common/MobileMainHeader'
import { useEventsArchivedQuery } from 'Queries/Events'
import React from 'react'
import { navigateToEventsListPage } from 'Scenes/navigators'

import { EventsCardList } from './EventsCardList'

const SceneEventsArchiveList = () => {
  const {
    data: events,
    isFetched: isFetchedEvents,
    hasNextPage: hasNextEventsPage,
    fetchNextPage: fetchNextEventsPage,
    isFetchingNextPage: isLoadingEvents,
  } = useEventsArchivedQuery()

  return (
    <>
      <MobileMainHeader />
      <Box
        component={Container}
        my={12}
      >
        <ArchiveInfoCard
          eventTypeName="Events"
          navigateTo={() => navigateToEventsListPage()}
        />
        <EventsCardList
          noContentText="No Events in Archive"
          data={events}
          isLoading={isLoadingEvents}
          isFetched={isFetchedEvents}
          hasNextPage={hasNextEventsPage}
          fetchNextPage={fetchNextEventsPage}
        />
      </Box>
    </>
  )
}

export default SceneEventsArchiveList
